module.exports = __webpack_public_path__ + "img/testimonial_2.333a2285.png";